import React from 'react';
import { withTheme, Grid, Card, Typography, CardContent, Tabs, Tab } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

import withStyles from '@material-ui/core/styles/withStyles';
import moment from '../../moment-hawaii';

import { useSwaggerClient } from '../../hooks/useSwaggerClient';

import config from '../../config';

function WeatherForecast({ theme }) {
    const [tab, setTab] = React.useState(0);

    const [forecastWeather] = useSwaggerClient('weather', 'getWeatherForecast');

    if (!forecastWeather) {
        return null;
    }

    const selectedDayWeather = forecastWeather[tab];

    const StyledTab = withStyles(() => ({
        root: {
            textTransform: 'none',
            '&$selected': {
                backgroundColor: theme.palette.primary.main,
                color: '#fff'
            }
        },
        selected: {}
    }))(props => <Tab disableRipple {...props} />);

    const StyledTabs = withStyles({
        indicator: {
            display: 'none'
        }
    })(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

    return (
        <Card className="weather-forecast-card">
            <CardContent>
                <Grid container spacing={2} className="weather-forecast">
                    <Grid item xs={12} md={12}>
                        <Typography style={{ fontSize: '1rem' }}>
                            {moment()
                                .add(+tab, 'days')
                                .format('dddd MMMM Do YYYY')}{' '}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={2}
                        container
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img
                            src={`${config.weatherIconsUrl}/${selectedDayWeather.icon}.png`}
                            alt="weather_icon"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={4}
                        container
                        alignItems="center"
                        direction="column"
                        justifyContent="center"
                    >
                        <Typography style={{ fontSize: '1.5rem' }}>
                            {selectedDayWeather.temperature.toFixed(0)}ºF
                        </Typography>
                        <Typography style={{ fontWeight: 'normal' }}>
                            {selectedDayWeather.description[0].toUpperCase() +
                                selectedDayWeather.description.slice(1)}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        className="weather-element"
                        container
                        direction="column"
                        justifyContent="center"
                    >
                        <Typography>
                            High: {selectedDayWeather.temperatureMax.toFixed(0)}º
                        </Typography>
                        <Typography>
                            Low: {selectedDayWeather.temperatureMin.toFixed(0)}º
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        className="weather-element"
                        container
                        direction="column"
                        justifyContent="center"
                    >
                        <Typography>Wind: {selectedDayWeather.wind}mph</Typography>
                        <Typography>Humidity: {selectedDayWeather.humidity}%</Typography>
                    </Grid>
                </Grid>
            </CardContent>
            <Divider />
            <div style={{ minWidth: 'none' }}>
                <StyledTabs
                    value={tab}
                    onChange={(event, newValue) => setTab(newValue)}
                    variant="fullWidth"
                    className="weather-tabs"
                    style={{ color: theme.palette.primary.main }}
                >
                    <StyledTab label={moment().format('ddd')} />
                    <StyledTab
                        label={`${moment()
                            .add(1, 'days')
                            .format('ddd')}`}
                    />
                    <StyledTab
                        label={moment()
                            .add(2, 'days')
                            .format('ddd')}
                    />
                    <StyledTab
                        label={moment()
                            .add(3, 'days')
                            .format('ddd')}
                    />
                    <StyledTab
                        label={moment()
                            .add(4, 'days')
                            .format('ddd')}
                    />
                </StyledTabs>
            </div>
        </Card>
    );
}

export default withTheme(WeatherForecast);
